<template>
  <v-dialog v-model="showDialog" max-width="700px" scrollable>
    <v-card min-height="50vh">
      <v-card-title> Event Form </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-text-field
              v-validate="'required'"
              v-model="name"
              label="Name"
              name="name"
            ></v-text-field>
            <error-message
              :error="errors.first('name')"
              :show="errors.has('name')"
            />
          </v-col>
          <v-col>
            <v-text-field
              v-model="url"
              v-validate="'required'"
              name="url"
              label="URL"
            ></v-text-field>
            <error-message
              :error="errors.first('url')"
              :show="errors.has('url')"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <vue-select
              v-model="timezone"
              :options="timezones"
              :menu-props="{ closeOnClick: true }"
              label="label"
              v-validate="'required'"
              name="timezone"
              autocomplete="new-password"
              style="margin-top: 0; padding-top: 0"
            >
              <template #header>
                <div>Timezone</div>
              </template>
            </vue-select>
            <error-message
              :error="errors.first('timezone')"
              :show="errors.has('timezone')"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-textarea label="Description" v-model="description"></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" sm="6" md="6">
            <flat-pickr
              :config="configs.dateTimePicker"
              class="time-picker"
              v-model="start_date_time"
              placeholder="Start Date Time"
              name="start_at"
              v-validate="'required'"
            >
            </flat-pickr>
            <span class="kt-font-danger validate-error">
              {{ errors.first('start_at') }}
            </span>
          </v-col>
          <v-col cols="6" sm="6" md="6">
            <flat-pickr
              :config="configs.dateTimePicker"
              class="time-picker"
              v-model="end_date_time"
              placeholder="End Date Time"
              name="end_at"
              v-validate="'required'"
            >
            </flat-pickr>
            <span class="kt-font-danger validate-error">
              {{ errors.first('end_at') }}
            </span>
          </v-col>
        </v-row>
        <template v-if="isAdmin">
          <v-row>
            <v-col>
              <v-autocomplete
                v-model="assign_to_companies"
                :items="companies"
                item-value="id"
                item-text="name"
                :menu-props="{ closeOnClick: true }"
                label="Assign to Companies"
                multiple
                prepend-icon="fal fa-user"
              >
                <template v-slot:prepend-item>
                  <v-list-item ripple @click="selectAllCompanies">
                    <v-list-item-action>
                      <v-checkbox v-model="selectedAllCompanies"></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title> Select All </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index < 3">
                    <span>{{ item.name }}</span>
                  </v-chip>
                  <span v-if="index === 3" class="grey--text caption">
                    (+{{ assignees.length - 3 }} others)
                  </span>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-autocomplete
                v-model="assign_to_dealers"
                :items="dealers"
                item-value="id"
                item-text="name"
                :menu-props="{ closeOnClick: true }"
                label="Assign to Dealers"
                multiple
                prepend-icon="fal fa-user"
              >
                <template v-slot:prepend-item>
                  <v-list-item ripple @click="selectAllDealers">
                    <v-list-item-action>
                      <v-checkbox v-model="selectAllDealers"></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title> Select All </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index < 3">
                    <span>{{ item.name }}</span>
                  </v-chip>
                  <span v-if="index === 3" class="grey--text caption">
                    (+{{ assignees.length - 3 }} others)
                  </span>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </template>

        <v-row>
          <v-col>
            <v-autocomplete
              v-model="assignees"
              :items="users"
              item-value="id"
              item-text="name"
              :menu-props="{ closeOnClick: true }"
              label="Assign to users"
              multiple
              prepend-icon="fal fa-user"
            >
              <template v-slot:prepend-item>
                <v-list-item ripple @click="selectAllUsers">
                  <v-list-item-action>
                    <v-checkbox v-model="selectedAll"></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title> Select All </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 3">
                  <span>{{ item.name }}</span>
                </v-chip>
                <span v-if="index === 3" class="grey--text caption">
                  (+{{ assignees.length - 3 }} others)
                </span>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <label> Is the Event Featured? </label>
            <v-switch class="d-inline" v-model="is_featured"></v-switch>
          </v-col>
          <v-col>
            <label> Is the Event Premium? </label>
            <v-switch class="d-inline" v-model="is_premium"></v-switch>
          </v-col>
        </v-row>
        <div class="float-right">
          <v-btn text @click="close" class="mr-4"> Cancel </v-btn>
          <v-btn color="primary" text @click="submit" :loading="loading">
            Save
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  forEach as _forEach,
  head as _head,
  isEmpty as _isEmpty,
  findIndex as _findIndex,
  map as _map,
  some as _some,
} from 'lodash-es';
import ErrorMessage from '@/components/form-components/ErrorMessage';
import dayjs from 'dayjs';

export default {
  name: 'EventFormDialog',
  components: { ErrorMessage },
  props: {
    fetchData: {
      type: Function,
      default() {
        this.$store.dispatch('events/getEvents', {
          month: dayjs().get('month') + 1,
          year: dayjs().get('year'),
        });
      },
    },
  },
  data() {
    return {
      configs: {
        dateTimePicker: {
          enableTime: true,
          dateFormat: 'm/d/Y G:i K',
        },
      },
      assignees: [],
      id: '',
      name: '',
      url: '',
      description: '',
      start_date_time: '',
      end_date_time: '',
      is_premium: false,
      is_featured: false,
      color: 'blue',
      loading: false,
      timezone: '',
      password: '',
      show_password: false,
      assign_to_dealers: [],
      assign_to_companies: [],
    };
  },
  computed: {
    users() {
      return this.$store.state.lmsClient.listUsers;
    },
    showDialog: {
      get() {
        this.setEvent();
        return this.$store.state.events.showEventFormDialog;
      },
      set(value) {
        this.$store.dispatch('events/setEventFormDialogState', value);
      },
    },
    editEvent() {
      return this.$store.state.events.selectedEvent;
    },
    selectedAllUsers() {
      return this.assignees.length === this.users.length;
    },
    selectedAllCompanies() {
      return this.assign_to_companies.length === this.companies.length;
    },
    selectedAllDealers() {
      return this.assign_to_dealers.length === this.dealers().length;
    },
    timezones() {
      return this.$store.state.timezones.timezones;
    },
    companies() {
      return this.$store.state.events.companies;
    },
    dealers() {
      return this.$store.state.events.dealers;
    },
    isAdmin() {
      return _some(this.$auth.user().roles, { name: 'super-administrator' });
    },
    isCompaniesInitialize() {
      return this.$store.state.events.isCompaniesInitialize;
    },
  },
  created() {
    if (!this.isCompaniesInitialize) {
      this.getCompaniesAndDealers();
      this.fetchUsers();
    }
  },
  methods: {
    fetchUsers() {
      this.$store
        .dispatch('lmsClient/fetchUsersByDealer')
        .then(({ data }) => {
          this.$store.dispatch('lmsClient/setUsers', data);
        })
        .catch(() => {
          console.log('error');
        });
    },
    getCompaniesAndDealers() {
      if (!_isEmpty(this.companies)) {
        return;
      }

      if (!this.isCompaniesInitialize) {
        this.$store.dispatch('events/setIsCompaniesInitialize', true);

        this.$http.get('/companies-and-dealers').then(({ data }) => {
          this.$store.dispatch('events/setCompaniesState', data.data.companies);
          this.$store.dispatch('events/setDealersState', data.data.dealers);
        });
      }
    },
    selectAllCompanies() {
      this.$nextTick(() => {
        if (this.selectedAllCompanies) {
          this.assign_to_companies = [];
        } else {
          this.assign_to_companies = this.companies.slice().map((item) => {
            return item.id;
          });
        }
      });
    },
    selectAllDealers() {
      this.$nextTick(() => {
        if (this.selectedAllDealers) {
          this.assign_to_dealers = [];
        } else {
          this.assign_to_dealers = this.dealers.slice().map((item) => {
            return item.id;
          });
        }
      });
    },
    selectAllUsers() {
      this.$nextTick(() => {
        if (this.selectAllUsers) {
          this.assignees = [];
        } else {
          this.assignees = this.users.slice().map((item) => {
            return item.id;
          });
        }
      });
    },
    setEvent() {
      if (_isEmpty(this.editEvent)) {
        return;
      }

      this.id = this.editEvent.id;
      this.name = this.editEvent.name;
      this.url = this.editEvent.url;
      this.description = this.editEvent.description;
      this.start_date_time = dayjs(this.editEvent.start).format(
        'MM/DD/YYYY hh:mm A'
      );
      this.end_date_time = dayjs(this.editEvent.end).format(
        'MM/DD/YYYY hh:mm A'
      );
      this.is_featured = this.editEvent.is_featured;
      this.is_open = this.editEvent.is_open;
      this.password = this.editEvent.password;
      const timezoneIndex = _findIndex(this.timezones, {
        timezone: this.editEvent.timezone,
      });
      this.timezone = this.timezones[timezoneIndex];
      if (this.editEvent.attendees) {
        this.assignees = _map(
          this.editEvent.attendees,
          (attendee) => attendee.assignee_id
        );
      }
    },
    submit() {
      const data = {
        id: this.id,
        name: this.name,
        url: this.url,
        start_at: this.start_date_time,
        end_at: this.end_date_time,
        color: this.color,
        description: _isEmpty(this.description) ? null : this.description,
        is_open: !this.is_premium === 1,
        is_featured: this.is_featured,
        assignees: this.assignees,
        timezone: this.timezone,
        password: this.password,
        companies: this.assign_to_companies,
        dealers: this.assign_to_dealers,
      };

      this.$validator.validate('*').then((isValid) => {
        if (isValid) {
          // eslint-disable-next-line eqeqeq,no-unused-expressions
          this.isLoading = true;
          if (Object.keys(this.editEvent).length === 0) {
            return this.createEvent(data);
          }
          return this.updateEvent(data);
        }
      });
    },
    createEvent(val) {
      this.loading = true;
      this.$http
        .post('/events', val)
        .then(({ data }) => {
          this.fetchData();
          this.loading = false;
          this.$notify('success', 'Event added');
          this.close();
        })
        .catch((errors) => {
          this.loading = false;

          this.interactWithErrorBag(errors, this.errors);
        });
    },
    updateEvent(payload) {
      this.loading = true;
      this.$http
        .patch(`/events/${payload.id}`, payload)
        .then(({ data }) => {
          this.fetchData();
          this.loading = false;
          this.$notify('success', 'Event updated');
          this.close();
        })
        .catch((errors) => {
          this.loading = false;
          this.interactWithErrorBag(errors, this.errors);
        });
    },
    close() {
      this.clear();
      this.$store.dispatch('events/setEventFormDialogState', false);
      this.$store.dispatch('events/setSelectedEvent', {});
    },
    clear() {
      this.id = null;
      this.name = '';
      this.url = '';
      this.start_date_time = null;
      this.end_date_time = null;
    },
  },
};
</script>

<style scoped></style>
